import { render, staticRenderFns } from "./return_details.vue?vue&type=template&id=2278a5ec&scoped=true&"
import script from "./return_details.vue?vue&type=script&lang=js&"
export * from "./return_details.vue?vue&type=script&lang=js&"
import style0 from "./return_details.vue?vue&type=style&index=0&id=2278a5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278a5ec",
  null
  
)

export default component.exports